import {
  ADD_ITEM_TO_CART_FAILURE,
  ADD_ITEM_TO_CART_REQUEST,
  ADD_ITEM_TO_CART_SUCCESS,
  GET_CART_FAILURE,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_FAILURE,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_SUCCESS,
  CLEAR_CART,
} from "./ActionType";

const initialState = {
  cart: null,
  loading: false,
  error: null,
  cartItems: [],
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ITEM_TO_CART_REQUEST:
      return { ...state, loading: true, error: null };
    case ADD_ITEM_TO_CART_SUCCESS:
      return {
        ...state,
        cartItems: [...state.cartItems, action.payload.cartItems],
        loading: false,
      };
    case ADD_ITEM_TO_CART_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_CART_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CART_SUCCESS:
      return {
        ...state,
        cartItems: action.payload.cartItems,
        cart:action.payload,
        loading: false,
      };
    case GET_CART_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case REMOVE_CART_ITEM_REQUEST:
    case UPDATE_CART_ITEM_REQUEST:
      return {
        ...state,
        // Don't set loading: true for optimistic updates
      };
    case REMOVE_CART_ITEM_SUCCESS:
      const updatedCartItems = state.cartItems.filter(
        (item) => item._id !== action.payload
      );
      // Recalculate cart totals optimistically
      const updatedCart = state.cart ? {
        ...state.cart,
        cartItems: updatedCartItems,
        totalItem: (state.cart.totalItem || 0) - 1,
        totalDiscountedPrice: updatedCartItems.reduce(
          (sum, item) => sum + (item.product?.discountedPrice || 0) * item.quantity, 0
        ),
        totalPrice: updatedCartItems.reduce(
          (sum, item) => sum + (item.product?.price || 0) * item.quantity, 0
        ),
        discounte: updatedCartItems.reduce(
          (sum, item) => sum + ((item.product?.price || 0) - (item.product?.discountedPrice || 0)) * item.quantity, 0
        ),
      } : null;
      
      return {
        ...state,
        cartItems: updatedCartItems,
        cart: updatedCart,
        loading: false,
      };
    case UPDATE_CART_ITEM_SUCCESS:
      // Optimistically update quantity in cartItems
      const updatedItems = state.cartItems.map((item) =>
        item._id === action.payload.cartItemId 
          ? { ...item, quantity: action.payload.quantity }
          : item
      );
      
      // Recalculate cart totals optimistically
      const recalculatedCart = state.cart ? {
        ...state.cart,
        cartItems: updatedItems,
        totalDiscountedPrice: updatedItems.reduce(
          (sum, item) => sum + (item.product?.discountedPrice || 0) * item.quantity, 0
        ),
        totalPrice: updatedItems.reduce(
          (sum, item) => sum + (item.product?.price || 0) * item.quantity, 0
        ),
        discounte: updatedItems.reduce(
          (sum, item) => sum + ((item.product?.price || 0) - (item.product?.discountedPrice || 0)) * item.quantity, 0
        ),
      } : null;
      
      return {
        ...state,
        cartItems: updatedItems,
        cart: recalculatedCart,
        loading: false,
      };
    case REMOVE_CART_ITEM_FAILURE:
    case UPDATE_CART_ITEM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CLEAR_CART:
      return {
        ...state,
        cart: null,
        cartItems: [],
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default cartReducer;
